import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const commonDataApi = createApi({
    reducerPath: "base/common/code",
    baseQuery: axiosBaseQuery,
    tagTypes: ["commonDataList"],
    endpoints: (builder) =>({
        commonDataFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['commonDataList'],
            query: (query = '') => ({
                url: "/base/common/code" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        commonDataCreate: builder.mutation({
            invalidatesTags: ['commonDataList'],
            query: (data)=>({url: "/base/common/code", method: "POST", data})
        }),
        commonDataUpdate: builder.mutation({
            invalidatesTags: ['commonDataList'],
            query: (data)=>({url: "/base/common/code/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        commonDataDelete: builder.mutation({
            invalidatesTags: ['commonDataList'],
            query: (id)=>({url: "/base/common/code/"+id, method: "DELETE"})
        }),
    })
})

export const { useCommonDataFindAllQuery, useCommonDataCreateMutation, useCommonDataUpdateMutation, useCommonDataDeleteMutation } = commonDataApi;
export {commonDataApi};
